var map = {
	"./client1.jpg": 7893,
	"./client2.jpg": 2170,
	"./client3.jpg": 9911,
	"./client4.jpg": 2012,
	"./icq1.jpg": 697,
	"./icq2.jpg": 9198,
	"./icq3.jpg": 9355,
	"./newsletter.jpg": 2262,
	"./proqual1.jpg": 5938,
	"./proqual2.jpg": 5837,
	"./proqual3.jpg": 256,
	"./seg1.jpg": 9835,
	"./seg2.jpg": 5180,
	"./seg4.jpg": 5338,
	"./sqa1.jpg": 3753,
	"./sqa2.jpg": 7614
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7248;